
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/live-support-status",
      function () {
        return require("private-next-pages/resources/live-support-status/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/live-support-status"])
      });
    }
  